import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Circle, Map, Marker, Popup, TileLayer} from 'react-leaflet';
import {InputNumber} from 'primereact/inputnumber';
import {Panel} from 'primereact/panel';
import {t} from 'i18next';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import ActionButton from '../../components/ActionButton';
import {buildNominatimSearchParams, nominatimParamsToQueryString} from '../../utils/NominatimUtils';

export const UserLocations = (props) => {
    const {locations, onAddLocation, onUpdateLocation, viewMode, validator, showErrorMessage, showSuccessMessage} = props;
    const [zoomLevel, setZoomLevel] = useState(6);

    const [city, setCity] = useState(undefined);
    const [streetName, setStreetName] = useState(undefined);
    const [streetNumber, setStreetNumber] = useState(undefined);
    const [postalCode, setPostalCode] = useState(undefined);
    const [houseNumber, setHouseNumber] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const handleZoomChange = (event) => {
        setZoomLevel(event.target.value);
    };
    const searchAddress = async (form) => {
        const queryString = nominatimParamsToQueryString(buildNominatimSearchParams(form));
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&${queryString}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Błąd podczas wyszukiwania adresu:', error);
            return null;
        }
    };

    const addMarker = (event) => {
        if (viewMode !== 'VIEW') {
            const lat = parseFloat(event.latlng.lat);
            const lng = parseFloat(event.latlng.lng);
            const precision = 18;
            const location = locations.find(
                (l) =>
                    parseFloat(l.latitude).toFixed(precision) === lat.toFixed(precision) &&
                    parseFloat(l.longitude).toFixed(precision) === lng.toFixed(precision)
            );

            if (location) {
                showErrorMessage('Lokalizacja już została dodana');
                return false;
            }
            const newMarker = {
                latitude: lat,
                longitude: lng,
                localizationTolerance: 0,
                id: undefined,
            };
            onAddLocation(newMarker);
            return true;
        }
    };

    const handleMarkerDrag = (index, event) => {
        if (viewMode !== 'VIEW') {
            const {lat, lng} = event.target.getLatLng();
            const updatedMarkers = [...locations];
            updatedMarkers[index] = {
                latitude: lat,
                longitude: lng,
                localizationTolerance: updatedMarkers[index].localizationTolerance,
                id: updatedMarkers[index].id,
            };
            onUpdateLocation(updatedMarkers);
        }
    };

    const removeMarker = (index) => {
        const updatedMarkers = [...locations];
        updatedMarkers.splice(index, 1);
        onUpdateLocation(updatedMarkers);
    };

    const onToleranceChange = (index, event) => {
        const updatedMarkers = [...locations];
        updatedMarkers[index].localizationTolerance = event.value;
        onUpdateLocation(updatedMarkers);
    };

    useEffect(() => {}, [locations]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        >
            <div className='col-12'>
                <div className='mb-4 mt-4'
                   
                >    <label className='p-label' style={{width: '100%'}}>
                              {t('mobileUser.location')}
                    </label>
                    <Map
                        center={[52.237, 21.017]}
                        zoom={zoomLevel}
                        style={{height: '500px', zIndex: '100'}}
                        onZoomEnd={handleZoomChange}
                        onClick={addMarker}
                    >
                        <TileLayer
                            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        {locations.map((location, index) => (
                            <Marker
                                key={index}
                                position={[location.latitude, location.longitude]}
                                draggable={viewMode !== 'VIEW'}
                                ondragend={(event) => handleMarkerDrag(index, event)}
                            >
                                <Popup>
                                    <label htmlFor='stacked-buttons' className='font-bold block mb-2'>
                                    {t('mobileUser.tolerance')}  
                                    </label>
                                    <InputNumber
                                        inputId='stacked-buttons'
                                        minFractionDigits={2}
                                        min={0}
                                        disabled={viewMode === 'VIEW'}
                                        label='tolerancja'
                                        className='mb-2'
                                        value={location.localizationTolerance}
                                        onChange={(e) => {
                                            onToleranceChange(index, e);
                                        }}
                                    />
                                    <br />
                                    <ActionButton
                                        rendered={viewMode !== 'VIEW'}
                                        label={t('mobileUser.remove-tolerance')}
                                        handleClick={() => removeMarker(index)}
                                        className={'float-right'}
                                    />
                                </Popup>
                                <Circle
                                    center={[location.latitude, location.longitude]}
                                    radius={location?.localizationTolerance ? location?.localizationTolerance * 1000 : 0}
                                />
                            </Marker>
                        ))}
                    </Map>
                </div>
            </div>
        </div>
    );
};

UserLocations.defaultProps = {
    viewMode: 'VIEW',
    locations: [],
};

UserLocations.propTypes = {
    viewMode: PropTypes.string,
    onAddLocation: PropTypes.func.isRequired,
    showErrorMessage: PropTypes.func.isRequired,
    validator: PropTypes.object.isRequired,
    onUpdateLocation: PropTypes.func.isRequired,
    locations: PropTypes.array,
};

export default UserLocations;
